export const REDUX_ACTIONS = {
  RESET_AQUA_ERROR: 'RESET_AQUA_ERROR',
  THROW_AQUA_ERROR: 'THROW_AQUA_ERROR',
  THROW_CUSTOM_AQUA_ERROR: 'THROW_CUSTOM_AQUA_ERROR',
  SET_IS_SHOWING_ERROR_SCREEN: 'SET_IS_SHOWING_ERROR_SCREEN',
};

export const ERROR_STRINGS = {
  uhOh: 'Uh oh!',
  checkYourInternetConnection: 'We recommend checking your internet connection.',
  theresBeenAnError: 'Something went wrong.',
};
